import React from "react";
import Navbar from "../components/layout/header/Navbar";
import Layout from "../components/layout/Layout";
import PageHeader from "../components/team/PageHeader";
import Footer from "../components/layout/footer/Footer";
import CabeceraSanPedro from "../components/destinosSecciones/CabeceraSanPedro";
import HoteleriaSanPedro from "../components/hoteleria/HoteleriaSanPedro";
import TransporteTerrestre from "../components/Transporte/TransporteTerrestre";
import VideoPromoDestino from "../components/promo/VideoPromoDestino";
import DiversionSanPedro from "../components/diversion/DiversionSanPedro";
import AsistenciaMedica from "../components/AsistenciaMedica/AsistenciaMedica";

export default function PriSanPedro() {
  return (
    <Layout>
    <Navbar darkBg />
    <PageHeader
      background={"assets/img/sanpedro/san-pedro.jpg"}
      HeaderTitle="San Pedro"
      Parent="primarios"
      PageTitle="San Pedro"
    />
    <CabeceraSanPedro destino={"San Pedro"} />
    <VideoPromoDestino
      background="assets/img/sanpedro/banner-sanpedro.jpg"
      YoutubeVideoId="X7iOrQ6Z4zw"
      TextoPromo="Conoce San Pedro, tu viaje de egresados."
    />
    {/* Para cambiar hoteleria y Galeria */}
    <HoteleriaSanPedro />
    <DiversionSanPedro hasBg={true} />
    {/*  */}
    <TransporteTerrestre />
    <AsistenciaMedica bgColor />
    <Footer />
  </Layout>
  );
}